export const environment = {
  production: false,
  useServiceWorker: false,
  googleLocaltionKey: '',
  apiKey: 'AIzaSyAXqYcPB5hsbdmwAhUE3WG_rNsKn6nvcOQ',
  authDomain: 'dev-notification-moneytor.firebaseapp.com',
  projectId: 'dev-notification-moneytor',
  storageBucket: 'dev-notification-moneytor.appspot.com',
  messagingSenderId: '1021676921919',
  appId: '1:1021676921919:web:e65cd9a95d1803428dc48a',
  measurementId: 'G-4YLXWZ8322',
  socket_url: 'https://dev-socket.moneytor.in',
  api_url: 'https://uat.moneytor.in',
  // STEP 10: Set to CommunicationConfigs.id for title IVR_CALL_LOG after UAT seed (0 = unset).
  ivrCallCommunicationConfigId: 6140,
  // Cube QuickCall — two independent transports; flip cube_dialer_mode / cube_sdk only
  // Master on/off for Cube calling widget + webphone iframe
  isCubeDialerAllowed: true,
  // 'sdk' = CubeConnector methods (cube-sdk/). 'iframe' = existing SSO + postMessage path
  cube_dialer_mode: 'sdk',
  cube_sdk: true,
  // Floating Cube webphone chrome. false = hidden iframe (audio only), Moneytor widget UI
  isCubeIframeVisible: false,
  // true = /api/cube-webphone proxy (iframe path). false = cube_webphone_url (SDK docs 3.2)
  cube_webphone_use_proxy: false,
  cube_webphone_url: 'https://quickdialer.in/moneytorconnWebphone',
  // SDK docs 3.1 CubeConnector script + postMessage origin (used when cube_dialer_mode is sdk)
  cube_connector_script: 'https://quickdialer.in/connector-test/cube-connector-v2.js',
  cube_connector_child_origin: 'https://quickdialer.in',
  // Auto-answer ringing Cube calls (no Accept click in the Moneytor widget)
  cube_auto_answer: true,
  ozonetel_dialer_enabled: true,
  ozonetel_dialer_mode: 'sdk',
  ozonetel_sdk: true,
  ozonetel_cloudagent_origin: 'https://agent.cloudagent.ozonetel.com',
  ozonetel_mdl_url:
    'https://in1-ccaas-api.ozonetel.com/CAServicesV3/mdlConnection.php',
  ozonetel_mdl_api_key: 'KK9319b9f3d2de36f2bb1d6027f1002ffd',
  ozonetel_sdk_auto_answer_inbound: false,
  ozonetel_inbound_toolbar_pick: false,
  ozonetel_inbound_dc_sip_audio: false,
};
